// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","373":"component---src-pages-home-tsx","886":"component---src-templates-article-js"}[chunkId] + "-" + {"218":"8c24b455787172c5f078","373":"adba46366b9a32d270f3","886":"0e11d47854b49efe6a3a"}[chunkId] + ".js";
};